(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layout-columnscontent"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("shopify:section:load", initReadMore);
document.addEventListener("DOMContentLoaded", initReadMore);

function initReadMore() {
  document.querySelectorAll(".read-more-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const aboutText = this.closest(".about-text");
      const shortText = aboutText.querySelector(".about-short");
      const fullText = aboutText.querySelector(".about-full");

      fullText.classList.toggle("hidden");
      const expanded = !fullText.classList.contains("hidden");

      // Update button text with styled icons
      this.innerHTML = expanded
        ? '<span style="font-size:22px; line-height:0;">&#8722;</span> Lees minder'
        : '<span style="font-size:22px; line-height:0;">&#43;</span> Lees meer';

      shortText.style.display = expanded ? "none" : "block";
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
